/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';
import type { Vaccine } from './Vaccine';
import {
    VaccineFromJSON,
    VaccineFromJSONTyped,
    VaccineToJSON,
} from './Vaccine';

/**
 * 
 * @export
 * @interface VaccinePagination
 */
export interface VaccinePagination {
    /**
     * 
     * @type {Array<Vaccine>}
     * @memberof VaccinePagination
     */
    data?: Array<Vaccine>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof VaccinePagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the VaccinePagination interface.
 */
export function instanceOfVaccinePagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VaccinePaginationFromJSON(json: any): VaccinePagination {
    return VaccinePaginationFromJSONTyped(json, false);
}

export function VaccinePaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): VaccinePagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(VaccineFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function VaccinePaginationToJSON(value?: VaccinePagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(VaccineToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

